import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface IWishStoreAddition {
  wish: IWishSliceState
}

interface IWishSliceState {
  wishLists?: IWishListDto[]
  isLoading: { [wishId: number]: boolean | undefined }
}

const initialState: IWishSliceState = {
  isLoading: {},
}

export const wishSlice = createSlice({
  name: "wish",
  initialState,
  reducers: {
    setWishLists: (state, action: PayloadAction<IWishListDto[]>) => {
      state.wishLists = action.payload
    },
    setIsLoading: (state, action: PayloadAction<{ wishId: number; isLoading: boolean }>) => {
      state.isLoading[action.payload.wishId] = action.payload.isLoading
    },
  },
})

export const wishActions = wishSlice.actions
export const wishSelectors = {
  wishLists: (state: IWishStoreAddition) => state.wish.wishLists,
  isLoading: (state: IWishStoreAddition, wishId: number) => !!state.wish.isLoading[wishId],
}
